$(document).ready(function () {
    $(".nav-list li").on('click', function (event) {
        event.preventDefault();
        $(".nav-list li").removeClass('active');
        $(this).addClass('active');
        $(".h-liked-col").removeClass('active');
        $(".h-liked-col").eq($(this).index(".nav-list li")).addClass('active');
    });

    $(".hotel-reviews-right li").on('mouseenter', function (event) {
        event.preventDefault();
        $(".hotel-reviews-right li").removeClass('hover');
        index = $(this).index(".hotel-reviews-right li") + 1;
        $(".hotel-reviews-right li:lt(" + index + ")").addClass('hover');

    });

    $(".hotel-reviews-right li").on('click', function (event) {
        event.preventDefault();
        $(".hotel-reviews-right li").removeClass('active');
        var index = $(this).index(".hotel-reviews-right li") + 1;
        $(".hotel-reviews-right li:lt(" + index + ")").addClass('active');
        $("#comment-vote").val(index);
    });

    $(".hotel-reviews-right li").on('mouseleave', function (event) {
        event.preventDefault();
        $(".hotel-reviews-right li").removeClass('hover');
    });

    //Sticky sidebar
    if($(".two-colls-left.sticky").length>0&&$(window).width()>910){$(".two-colls-left.sticky").stick_in_parent();};
    

    //Tabela porównanie
    if($("#opis-porowananie-wrap").length>0){
        //$("#opis-porowananie-wrap").width(20+$(".table-obiekt").outerWidth()*$(".table-obiekt").length);
    };

    //Banner top
    if($(".header-banner").length>0){
         $(".main-cont").css('padding-top', $(".header-banner").outerHeight());
    };
    $(".has-submenu > a").on("click", function(e){
        e.preventDefault();
        $(this).closest(".has-submenu").toggleClass('open');
    })
    $('.group-footer-btn').on("click", function(e) {
        e.preventDefault()
        $(this).addClass("open")
        $(".compare-footer-btn").removeClass("open")
        $('.compare-bottom-content').hide()
        $(".group-bottom-content").show()
    })
    $('.compare-footer-btn').on("click", function(e) {
        e.preventDefault()
        $(this).addClass("open")
        $(".group-footer-btn").removeClass("open")
        $('.compare-bottom-content').show()
        $(".group-bottom-content").hide()
    })
    $(window).on('load', function() {
        if ($(".footer-compare-group-panel .viewed-item").length > 0) {
            $(".footer-compare-group-panel").addClass("open");
            if ($(".group-bottom-content .viewed-item").length > 0) {
                $('.group-footer-btn').addClass('open')
                $(".compare-footer-btn").removeClass("open")
                $('.compare-bottom-content').hide()
                $(".group-bottom-content").show()
            } else {
                $('.compare-footer-btn').addClass('open')
                $(".group-footer-btn").removeClass("open")
                $('.compare-bottom-content').show()
                $(".group-bottom-content").hide()
            }
        }
    })

});